var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card-title",
            [
              _vm._v(" Migration Details "),
              _c(
                "router-link",
                {
                  staticClass: "body-2 pl-md-2",
                  attrs: {
                    to: {
                      name: "migrations"
                    }
                  }
                },
                [_vm._v(" Back to migrations list ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.loading && !_vm.migration
        ? _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex justify-center pt-4"
                },
                [
                  _c("v-progress-circular", {
                    attrs: {
                      indeterminate: "",
                      size: "64",
                      color: "primary"
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.migration
        ? _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c("migration-details-card", {
                attrs: {
                  migration: _vm.migration
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.hasSubaccounts
        ? _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c("sub-migrations-card", {
                attrs: {
                  "sub-migrations": _vm.migration.subaccounts
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.migration && _vm.migration.can_early_start
        ? _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c("migration-start-card", {
                attrs: {
                  migration: _vm.migration
                },
                on: {
                  "get-migration-data": _vm.getMigrationDetails
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.migration && _vm.migration.messages.length
        ? _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "h2",
                {
                  staticClass: "py-3"
                },
                [_vm._v("Messages")]
              ),
              _c("migration-messages-card", {
                attrs: {
                  migration: _vm.migration
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }